// import vueDropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { api } from '@/f1/service';
// import md5 from 'md5';
import forge from 'node-forge';
import { Switch as cSwitch } from '@coreui/vue';
import Language from './language';


const _i18n_data = {
  saved: {
    EN : `saved`,
    KO : `저장되었습니다`,
  },
  updated: {
    EN : `updated`,
    KO : `업데이트되었습니다`,
  },
  removed: {
    EN : `removed`,
    KO : `삭제되었습니다`,
  },
};


export default {
  components: { cSwitch, Language },
  data : () => {
    return {
      file : undefined,
      confirm: false,
      add: false,
      lock: true,
      model : { hash : '', cause : '' }
    }
  },
  computed: { i18n_data() { return _i18n_data; } }, // i18n 메세지 변환용.
  methods: {
    list() { this.$emit('refresh'), this.$router.push({ name: 'wsfinder_hash'}); },
    bs_file(file) {
      try {
        let fr = new FileReader();
        let f = file.target.files[0] ? file.target.files[0] : file.dataTransfer.files[0];
        if(!f) { console.log('no have a file'); return; } else { this.model.cause = f.name; }
        if(f.size > 5242880) { this.$toastr.w('Maximum file size exceeded.'); return; }

        fr.onload = async x => { console.log(x);  this.model.hash = await forge.md5.create().update(forge.util.createBuffer(fr.result).data).digest().toHex(); }
        fr.readAsArrayBuffer(f);
      } catch (e) {
        console.log(e)
      }
    },
    async remove() {
      try {
        await api.wsfinder.WSFinder_Call('hash', 'delete', { id : this.model.id })
        this.$toastr.s(this.i18n_data['removed'][this.i18n]); this.list()
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText) , this.list() }
    },
    async get(id = this.$route.params.id) {
      if (id == 'add' | id == 'edit') { this.lock = false; return; }
      try {
        let rs = await api.wsfinder.WSFinder_Call('hash', 'detail', { id : id })
        this.model = Object.assign({}, this.model, rs.body)
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText) , this.list() }
    },
    async save() {
      if(!(this.model.hash || '').trim()) { return this.$toastr.e(e.data ? e.data.message : e.statusText)('File selection required.'); }
      try {
        await api.wsfinder.WSFinder_Call('hash', this.model.id ? 'update' : 'insert', this.model);
        this.$toastr.s(this.i18n_data['saved'][this.i18n]);
        this.$emit('refresh');
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText) , this.list() }
      this.lock = true;
    },
  },
  watch: { '$route' (to, from) { this.get(to.params.id); } },
  created: function() {   console.log('hash.detail.vue', 'created'); },
  destroyed: function() { console.log('hash.detail.vue', 'destroyed'); },
  mounted: function() { console.log('hash.detail.vue', 'mounted'); this.get(this.$route.params.id); },
}
